import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.login');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-login',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.login/view.scss */
:host {
  display: block;
  height: 100%;
}

.login-brand-panel {
  background: linear-gradient(135deg, #18181b 0%, #1e293b 60%, #172554 100%);
}

.login-orb {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
}

.login-orb-1 {
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(59, 130, 246, 0.15) 0%, transparent 70%);
  top: -100px;
  right: -100px;
}

.login-orb-2 {
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(59, 130, 246, 0.08) 0%, transparent 70%);
  bottom: -150px;
  left: -150px;
}

.login-orb-3 {
  width: 200px;
  height: 200px;
  background: radial-gradient(circle, rgba(37, 99, 235, 0.1) 0%, transparent 70%);
  top: 40%;
  left: 30%;
}

.login-input {
  transition: all 0.2s ease;
}
.login-input:focus {
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.08);
}
.login-input.login-input-error {
  border-color: #fca5a5;
  background: #fff;
}
.login-input.login-input-error:focus {
  border-color: #dc2626;
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.08);
}

.login-btn {
  transition: all 0.15s ease;
}
.login-btn:active {
  transform: scale(0.98);
}`],
})
export class PageLoginComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(false, "/fund/formed");
    }

    public view: string = 'login';
    public loginError: string = '';

    public data: any = {
        email: '',
        password: ''
    };

    public clearLoginError() {
        if (this.loginError) this.loginError = '';
    }

    public async showLoginError(message: string) {
        this.loginError = message || "이메일 또는 비밀번호를 확인해주세요";
        await this.service.render();
        setTimeout(() => {
            document.querySelector("input[type=password]").focus();
        }, 150);
    }

    public async alert(message: string, status: string = 'error', cancel: any = false, action: string = '확인') {
        return await this.service.alert.show({
            title: "",
            message: message,
            cancel: cancel,
            actionBtn: status,
            action: action,
            status: status
        });
    }

    public async login() {
        this.clearLoginError();

        let user = JSON.parse(JSON.stringify(this.data));
        if (!user.password)
            delete user.password;
        else
            user.password = this.service.auth.hash(user.password);

        let { code, data } = await wiz.call("login", user);

        if (code == 200) {
            const userId = (data && typeof data === 'object') ? data.user_id : data;
            const redirect = (data && typeof data === 'object' && data.redirect) ? data.redirect : "/community/notice/list";
            if (typeof AppInterface != 'undefined') {
                AppInterface.assignUserId(userId);
            }

            location.href = redirect;
        } else if (code == 201) {
            this.view = "login";
            await this.service.render();
            setTimeout(() => {
                document.querySelector("input[type=password]").focus();
            }, 150);
        } else if (code == 301) {
            let isjoin = await this.alert(data, 'success', '닫기', '계정 만들기');
            if (!isjoin) return;
            this.view = "join.terms";
            await this.service.render();
        } else if (code == 401 || code == 404) {
            await this.showLoginError(data);
        } else {
            await this.alert(data, 'error');
        }
    }

}

export default PageLoginComponent;